export default "__VITE_ASSET__BPWiKYi9__"